import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "border border-dark border-1 rounded-lg" }
const _hoisted_2 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "mt-3 d-flex flex-wrap"
}
const _hoisted_7 = { class: "dropdown me-3" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_10 = ["onClick", "onKeyup"]
const _hoisted_11 = { style: {"display":"inline-block"} }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = {
  class: "text-muted fst-italic me-3",
  style: {"font-size":"0.8rem"}
}
const _hoisted_14 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_15 = { class: "form-check form-switch me-2" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "mt-3 responsive-overflow d-none d-sm-block" }
const _hoisted_18 = { class: "d-flex justify-content-between slider-container" }
const _hoisted_19 = {
  key: 0,
  class: "flex-grow-1"
}
const _hoisted_20 = { class: "d-flex flex-row justify-content-center mt-2" }
const _hoisted_21 = { class: "d-sm-none" }

import { ref, reactive, computed, watch, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import { Retiree } from "@/guiide/ts/retiree";
import { createModernIncomeArray, tickCount, tickUnits, getDisabledClasses, calculateRequiredChartProjection, generateSteps, calculateBaseValueFromProjectedValue } from "@/guiide/ts/wants/wantsUtilities";
import { isJanuaryFirst, roundUp, roundUpToNearest } from "@/guiide/ts/utilities";
import { InitialIncomeProfile } from "@/guiide/ts/wants/initialIncomeProfile";
import { ChartView } from "@/guiide/ts/wants/chartView";
import IncomeDescriber from "./IncomeDescriber.vue";
import AnnualExpense from "./AnnualExpense.vue";
import IncomeScale from "./IncomeScale.vue";
import Modal from "@/guiide/components/common/Modal.vue";
import InitialIncomeSetup from './InitialIncomeSetup.vue';
import Help from "@/guiide/components/common/Help.vue";
import HelpText from "@/guiide/ts/helpText";
import ViewMode from "@/guiide/ts/wants/viewMode";
import Constants from "@/guiide/ts/constants";
import MobileIncomeChart from "./MobileIncomeChart.vue";
import YearEditor from "./YearEditor.vue";
import EditableProjectionQuery from "./EditableProjectionQuery.vue";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

type ReadState = { componentStateIsReadOnly: boolean, siteConfigStateIsRestricted: boolean, editButtonsDisabled: boolean, slidersDisabled: boolean };
type InflationDropdownInfo = { abbrevText: string, text: string, subtext: string, adjust: boolean };

const minIncome = 7200;
const minScaleValue = 1000;
const maxScaleValue = 10000000;
const scaleHundredsThreshold = 400;


export default /*@__PURE__*/_defineComponent({
  __name: 'AnnualExpenses',
  props: {
    isNewUser: { type: Boolean, default: false },
    inflationIncreaseEnabled: { type: Boolean, default: false },
    inflationAgeLimit: { type: Number, default: 200 }
},
  setup(__props, { expose: __expose }) {

const props = __props;

const initialPlanningYear = ref(new Date().getFullYear());
const retiringOnJanFirst = ref(false);
const maxIncome = ref(30000);
const annualIncomes = reactive(new Array<number>());
const mobileData = reactive(new Array<number>());
const step = ref(Constants.IncomeStepSize);
let tempStorageOfAnnualIncomesReInf: Array<number> = [];
const selectedYear = ref(0);
const showInflationAdjusted = ref(true);
const showWhatThisIsWorthToday = ref(false);

const incomeSetupModal = ref(null);
const incomeSetupModalUI = ref(null);
const yearIncomeModal = ref(null);
const yearIncomeModalTitle = ref("Year n income");
const yearIncomeModalUI = ref(null);
const incomeEditModeModal = ref(null);
const incomeEditModeModalUI = ref(null);

const inflationDropDownBtn = ref(null);
const inflationPresentationChoiceVisible = ref(true);
const beforeIncreasesDropdownItem: InflationDropdownInfo = { abbrevText: 'Not including increases', text: 'Not including increases', subtext: 'Annual income without the increases added', adjust: false };
const afterIncreasesDropdownItem: InflationDropdownInfo = { abbrevText: 'Including increases ', text: 'Including increases', subtext: 'Annual income with wanted increases', adjust: true };
const inflationDropdownItems = [beforeIncreasesDropdownItem, afterIncreasesDropdownItem];
const selectedInflationItem = ref(inflationDropdownItems[1]);

let planYears = 0;
let chartView: ChartView = { viewMode: ViewMode.AfterInflationNominal, inflationDurationYears: null };
const presentationUpdateOngoing = ref(false);
const quickSetValuesTracker = reactive({ baseIncome: 0, extraIncome: 0, extraIncomeYears: 5 } as InitialIncomeProfile);
const store = useStore();
const bootstrap: any = (window as any).bootstrap;

onMounted(() => {
    if (isReadOnly.value.siteConfigStateIsRestricted) {
        showInflationAdjusted.value = true;
        showWhatThisIsWorthToday.value = false;
        chartView = getRequiredChartView();
    }
});

watch(
    () => store.state.retiree,
    (newRetiree: Retiree) => {
        if (newRetiree == null) {
            return;
        }

        planYears = newRetiree.lifeExpectancy;

        const retirementDate = new Date(newRetiree.retirementDate);
        initialPlanningYear.value = retirementDate.getFullYear();
        retiringOnJanFirst.value = isJanuaryFirst(retirementDate);

        const userHasNotDefinedModernExpenses = newRetiree.requirements.income.length == 0;
        if (userHasNotDefinedModernExpenses) {
            return;
        }

        const incomeIncreasesWithInflation = newRetiree.requirements.incomeIncreasesWithInflation;
        const inflationDropdownItem = incomeIncreasesWithInflation
            ? afterIncreasesDropdownItem
            : beforeIncreasesDropdownItem;
        setSelectedDropdownItem(inflationDropdownItem);

        setIncome(newRetiree.requirements.income);
    }
);

const getIncome = function (): Array<number> {
    const incomeSource = incomeIsCurrentlyHeldInTempStorage() ? tempStorageOfAnnualIncomesReInf : annualIncomes;
    return Array.from({ length: Constants.MaxPlanYears }, (_, index) => incomeSource[index] || 0);
}

async function setIncome(newAnnualIncomes: Array<number>) {
    if (incomeIsCurrentlyHeldInTempStorage()) {
        tempStorageOfAnnualIncomesReInf = newAnnualIncomes;
        const force = true;
        const immediate = !hasData.value;
        updateChartPresentation(force, immediate);
    } else {
        const isInitialSetup = annualIncomes.length == 0;

        if (isInitialSetup) {
            const zeroIncomesForTransition = Array.from({ length: Constants.MaxPlanYears }, (_, index) => 0);
            annualIncomes.splice(0, annualIncomes.length, ...zeroIncomesForTransition);
        }

        await rebindChartData(newAnnualIncomes);
    }
}

__expose({ getIncome, setIncome });

const isInReadOnlyProjection = computed<boolean>(() => {
    return showInflationAdjusted.value || showWhatThisIsWorthToday.value;
});

const isReadOnly = computed<ReadState>(() => {
    const componentStateIsReadOnly = !hasData.value || isInReadOnlyProjection.value;
    const siteConfigStateIsRestricted = !store.state.configuration.requirementsExpenseEditPriviledges;
    const slidersDisabled = siteConfigStateIsRestricted ? true : componentStateIsReadOnly;
    // Edit buttons not disabled by read only component state as clicking on them will query the user as to whether they
    // want the component state to be changed to editable.
    const editButtonsDisabled = !hasData.value || siteConfigStateIsRestricted;

    const readState = { componentStateIsReadOnly, siteConfigStateIsRestricted, editButtonsDisabled, slidersDisabled };
    return readState;
});

const hasData = computed<boolean>(() => {
    return annualIncomes.length > 0 && annualIncomes.some(ai => ai != 0);
});

const topBarVisible = computed<boolean>(() => {
    if (props.isNewUser) {
        return !isReadOnly.value.siteConfigStateIsRestricted;
    }

    return true;
});

const editVisible = computed<boolean>(() => {
    return !isReadOnly.value.siteConfigStateIsRestricted;
});

const setAllVisible = computed<boolean>(() => {
    return !props.isNewUser;
});

const rangeControlsVisible = computed<boolean>(() => {
    return !isReadOnly.value.siteConfigStateIsRestricted;
});

const projectionControlsVisible = computed<boolean>(() => {
    return !isReadOnly.value.siteConfigStateIsRestricted;
});

const presentationChoiceButtonsDisabled = computed<boolean>(() => {
    if (!hasData.value) {
        return true;
    }

    if (showInflationAdjusted.value || showWhatThisIsWorthToday.value) {
        return false;
    }

    return isReadOnly.value.componentStateIsReadOnly;
});

const setAllText = computed<string>(() => {
    return isReadOnly.value.siteConfigStateIsRestricted ? "Edit" : "Set all";
});

const computedInflationIncreaseEnabled = computed<boolean>(() => props.inflationIncreaseEnabled);
watch(
    () => computedInflationIncreaseEnabled.value,
    (newValue: boolean) => {
        const inflationItem = newValue ? afterIncreasesDropdownItem : beforeIncreasesDropdownItem;
        setSelectedDropdownItem(inflationItem);
        inflationPresentationChoiceVisible.value = newValue;
    }
);

async function showSetupModal() {
    const suppressProjectionCheck = true;
    await initiateEditAction(async () => {
        incomeSetupModal.value.showModal(incomeSetupModalUI.value.initialize);
        return Promise.resolve();
    }, suppressProjectionCheck);
}

function closeSetupModal() {
    incomeSetupModal.value.closeModal();
}

function setupIncome(initialIncomeProfile: InitialIncomeProfile) {
    const retiree: Retiree = store.state.retiree;
    const totalPlanYears = retiree.lifeExpectancy;

    const incomeArray = createModernIncomeArray(
        initialIncomeProfile.baseIncome,
        initialIncomeProfile.extraIncome,
        initialIncomeProfile.extraIncomeYears,
        totalPlanYears,
        Constants.IncomeStepSize);

    setIncome(incomeArray);

    quickSetValuesTracker.baseIncome = initialIncomeProfile.baseIncome;
    quickSetValuesTracker.extraIncome = initialIncomeProfile.extraIncome;
    quickSetValuesTracker.extraIncomeYears = initialIncomeProfile.extraIncomeYears;

    closeSetupModal();
}

function onMobileEditClicked() {
    if (isReadOnly.value.siteConfigStateIsRestricted) {
        showSetupModal();
    } else {
        showYearIncomeModal();
    }
}

function showYearIncomeModal() {
    initiateEditAction(() => {
        yearIncomeModalTitle.value = `Year ${selectedYear.value + 1}`;
        yearIncomeModalUI.value.setIncome(annualIncomes[selectedYear.value]);
        yearIncomeModal.value.showModal(yearIncomeModalUI.value.initialize);
        return Promise.resolve();
    });
}

async function onDecrementIncomeClicked() {
    await initiateEditAction(async () => {
        const newIncome = annualIncomes[selectedYear.value] - Constants.IncomeStepSize;
        await updateIndividualIncomeValue(newIncome);
    });
}

async function onIncrementIncomeClicked() {
    await initiateEditAction(async () => {
        const newIncome = annualIncomes[selectedYear.value] + Constants.IncomeStepSize;
        await updateIndividualIncomeValue(newIncome);
    });
}

async function initiateEditAction(actor: () => Promise<void>, suppressProjectionCheck = false) {
    if (isInReadOnlyProjection.value && !suppressProjectionCheck) {
        incomeEditModeModal.value.showModal();
        return;
    }

    await actor();
}

function closeYearIncomeModal() {
    yearIncomeModal.value.closeModal();
}

function closeIncomeEditModeModal() {
    incomeEditModeModal.value.closeModal();
}

async function updateYearIncome(newIncome: number) {
    yearIncomeModal.value.closeModal();
    await updateIndividualIncomeValue(newIncome);
}

async function updateIndividualIncomeValue(newIncome: number) {
    newIncome = roundUp(newIncome, Constants.IncomeStepSize);
    const chartIsInBaseView = chartView.viewMode == ViewMode.BeforeInflationNominal;

    if (chartIsInBaseView) {
        const newIncomeArray = new Array<number>();
        annualIncomes.forEach((value: number, index: number) => { newIncomeArray.push(value) });
        newIncomeArray[selectedYear.value] = newIncome;
        await rebindChartData(newIncomeArray);
    } else {
        const baseAmountFromProjectedAmount = calculateBaseValueFromProjectedValue(chartView, newIncome, selectedYear.value, Constants.IncomeStepSize);
        tempStorageOfAnnualIncomesReInf[selectedYear.value] = baseAmountFromProjectedAmount;
        const force = true;
        await updateChartPresentation(force);
    }
}

async function increaseScale() {
    if (maxIncome.value > maxScaleValue) {
        return;
    }

    const increment = roundUpToNearest(maxIncome.value / tickCount, tickUnits);
    const newMax = maxIncome.value + increment;
    const fast = true;
    await updateTheScale(newMax, fast);
}

async function resetTheScaleIfRequired() {
    const scaleEvaluationResult = checkNewChartNumbersToSeeIfScaleNeedsToChange(annualIncomes);

    if (scaleEvaluationResult.needsToChange) {
        await updateTheScale(scaleEvaluationResult.newMax);
    }
}

function roundAtHundredPoint(num: number): number {
    const hundredsValue = num % 1000;

    if (hundredsValue < scaleHundredsThreshold) {
        return Math.floor(num / 1000) * 1000;
    } else {
        return Math.ceil(num / 1000) * 1000;
    }
}

watch([showInflationAdjusted, showWhatThisIsWorthToday], async () => await updateChartPresentation());

const computedInflationAgeLimit = computed<number>(() => props.inflationAgeLimit);
watch(computedInflationAgeLimit, async () => await updateChartPresentation());

async function updateChartPresentation(force = false, immediate = false) {
    presentationUpdateOngoing.value = true;

    if (!hasData.value && tempStorageOfAnnualIncomesReInf.length == 0) {
        presentationUpdateOngoing.value = false;
        return;
    }

    const newChartView = getRequiredChartView();

    if (!force && !hasChartViewChanged(newChartView)) {
        presentationUpdateOngoing.value = false;
        return;
    }

    let newChartNumbers: Array<number>;

    if (newChartView.viewMode == ViewMode.BeforeInflationNominal) {
        newChartNumbers = tempStorageOfAnnualIncomesReInf;
        tempStorageOfAnnualIncomesReInf = [];
    } else {
        ensureBeforeInflationNominalNumbersInTempStorage();
        newChartNumbers = calculateRequiredChartProjection(newChartView, tempStorageOfAnnualIncomesReInf, Constants.IncomeStepSize);
    }

    await rebindChartData(newChartNumbers, immediate);

    chartView = newChartView;
    presentationUpdateOngoing.value = false;
}

function incomeIsCurrentlyHeldInTempStorage(): boolean {
    return chartView.viewMode != ViewMode.BeforeInflationNominal;
}

function hasChartViewChanged(newChartView: ChartView): boolean {
    if (chartView.viewMode != newChartView.viewMode) {
        return true;
    }

    if (chartView.inflationDurationYears != newChartView.inflationDurationYears) {
        return true;
    }

    return false;
}

function getRequiredChartView(): ChartView {
    let viewMode: ViewMode;
    let inflationDurationYears: null | number = null;

    if (showInflationAdjusted.value) {
        viewMode = showWhatThisIsWorthToday.value ? ViewMode.AfterInflationReal : ViewMode.AfterInflationNominal;
        inflationDurationYears = computedInflationAgeLimit.value;
    } else {
        viewMode = showWhatThisIsWorthToday.value ? ViewMode.BeforeInflationReal : ViewMode.BeforeInflationNominal;
    }

    return { viewMode, inflationDurationYears };
}

function checkNewChartNumbersToSeeIfScaleNeedsToChange(newChartNumbers: number[]): { needsToChange: boolean, newMax: number } {

    const currentMax = Math.max(...newChartNumbers);

    let recalibrationRequired = false;

    const adjustor = 1.22;
    const preciseScaleMax = currentMax * adjustor;
    let idealScaleMax = roundAtHundredPoint(preciseScaleMax);

    if (preciseScaleMax < minScaleValue && currentMax < scaleHundredsThreshold) {
        idealScaleMax = minScaleValue;
        recalibrationRequired = true;
    } else if (preciseScaleMax < minScaleValue) {
        idealScaleMax = minScaleValue + 1000;
        recalibrationRequired = true;
    }

    if (currentMax >= maxIncome.value) {
        recalibrationRequired = true;
    } else {
        const driftFromIdeal = Math.abs(idealScaleMax - maxIncome.value);
        const allowedDriftFactor = 0.05;
        const allowedDrift = allowedDriftFactor * idealScaleMax;
        recalibrationRequired = recalibrationRequired || driftFromIdeal > allowedDrift;
    }

    return recalibrationRequired
        ? { needsToChange: true, newMax: idealScaleMax }
        : { needsToChange: false, newMax: 0 };
}

async function updateTheScale(newMax: number, fast = false) {
    const steps = 50;
    const scaleTransSteps = generateSteps(maxIncome.value, newMax, steps);
    const timeout = 7;
    await processArrayWithTimeout<number>(scaleTransSteps, 0, (index, maxValue) => maxIncome.value = maxValue, timeout);
}

async function processArrayWithTimeout<TArrayContent>(array: Array<TArrayContent>, index = 0, actor: (index: number, array: TArrayContent) => void, timeout: number): Promise<void> {
    if (index >= array.length) {
        return;
    }

    actor(index, array[index]);

    await new Promise(resolve => setTimeout(resolve, timeout));
    await processArrayWithTimeout(array, index + 1, actor, timeout);
}

async function rebindChartData(newData: Array<number>, immediate = false) {
    const scaleEvaluationResult = checkNewChartNumbersToSeeIfScaleNeedsToChange(newData);
    const changeScaleFirst = scaleEvaluationResult.newMax > maxIncome.value;

    const checkScale = async function () {
        if (scaleEvaluationResult.needsToChange) {
            await updateTheScale(scaleEvaluationResult.newMax);
        }
    };

    const pauseBetweenMovements = 200;

    if (changeScaleFirst) {
        await checkScale();
        await new Promise(resolve => setTimeout(resolve, pauseBetweenMovements));
    }

    await transitionSliders(newData, immediate);

    if (!changeScaleFirst) {
        await new Promise(resolve => setTimeout(resolve, pauseBetweenMovements));
        await checkScale();
    }
}

async function transitionSliders(newData: Array<number>, immediate = false) {
    newData.slice(0, planYears).forEach((value: number, index: number) => { mobileData[index] = value });

    if (immediate) {
        newData.forEach((value: number, index: number) => { annualIncomes[index] = value; });
        return;
    }

    step.value = 1;
    await nextTick();

    const steps = 61; //113; //73; //83;
    const timeout = 1; //5;
    const transitions = new Array<Array<number>>(newData.length);

    for (let i = 0; i < newData.length; i++) {
        transitions[i] = generateSteps(annualIncomes[i], newData[i], steps, (v) => Math.round(v));
    }

    const projections = new Array<Array<number>>(steps);
    for (let step = 0; step < steps; step++) {
        projections[step] = transitions.map(transition => transition[step]);
    }

    const projectionActor = function (index: number, array: Array<number>) {
        array.forEach((value: number, index: number) => {
            annualIncomes[index] = value;
        });
    }

    await processArrayWithTimeout(projections, 0, projectionActor, timeout);

    step.value = Constants.IncomeStepSize;
    await nextTick();
}

function ensureBeforeInflationNominalNumbersInTempStorage() {
    const alreadyCaptured = tempStorageOfAnnualIncomesReInf.length > 0;

    if (alreadyCaptured) {
        return;
    }

    annualIncomes.forEach((value: number) => {
        tempStorageOfAnnualIncomesReInf.push(value);
    });
}

function increasesDropdownItemEnter(item) {
    bootstrap.Dropdown.getInstance(inflationDropDownBtn.value).hide();
    increasesDropdownItemClick(null, item);
}

function increasesDropdownItemClick(event, item) {
    if (event) {
        event.preventDefault();
    }

    setTimeout(function () {
        setSelectedDropdownItem(item);
        inflationDropDownBtn.value.focus();
    }, 400);
}

function setSelectedDropdownItem(item: InflationDropdownInfo) {
    selectedInflationItem.value = item;
    showInflationAdjusted.value = item.adjust;
}

function onMobileChartYearSelected(year: number) {
    selectedYear.value = year;
}

async function onEditModeRequired() {
    incomeEditModeModal.value.closeModal();
    setSelectedDropdownItem(beforeIncreasesDropdownItem);
    showWhatThisIsWorthToday.value = false;
}

function editModeConfirmationAria(): string {
    return "Close button. To make it clearer, this chart is only editable when viewed with no increases added and not being shown in today's money. "
        + "Do you want to switch to this view so you can edit any particular year? Tab to yes button, enter to close.";
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (topBarVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (editVisible.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-outline-secondary btn-sm me-2 d-none d-sm-inline",
                  onClick: showYearIncomeModal,
                  disabled: isReadOnly.value.editButtonsDisabled
                }, "Edit", 8, _hoisted_3))
              : _createCommentVNode("", true),
            (setAllVisible.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-outline-secondary btn-sm me-2 d-none d-sm-inline",
                  onClick: showSetupModal
                }, _toDisplayString(setAllText.value), 1))
              : _createCommentVNode("", true),
            (rangeControlsVisible.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary btn-sm me-2 d-none d-sm-inline",
                    onClick: increaseScale,
                    disabled: isReadOnly.value.editButtonsDisabled
                  }, "Increase range", 8, _hoisted_4),
                  _createElementVNode("button", {
                    class: "btn btn-outline-secondary btn-sm me-2 d-none d-sm-inline",
                    onClick: resetTheScaleIfRequired,
                    disabled: isReadOnly.value.editButtonsDisabled
                  }, "Reset range", 8, _hoisted_5)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (projectionControlsVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                ref_key: "inflationDropDownBtn",
                ref: inflationDropDownBtn,
                type: "button",
                class: "btn btn-outline-secondary rounded p-2 d-flex align-items-center dropdown-toggle bg-white",
                disabled: presentationChoiceButtonsDisabled.value,
                id: "dropdownMenuButton",
                "data-bs-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["me-2 form-check-label text-muted inflation-dropdown", { 'disabled': presentationChoiceButtonsDisabled.value }])
                }, _toDisplayString(selectedInflationItem.value.abbrevText), 3)
              ], 8, _hoisted_8),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(inflationDropdownItems, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createElementVNode("div", {
                      class: "dropdown-item p-1 px-2 d-flex align-items-center",
                      tabindex: "0",
                      onClick: _withModifiers(($event: any) => (increasesDropdownItemClick($event, item)), ["prevent"]),
                      onKeyup: _withKeys(($event: any) => (increasesDropdownItemEnter(item)), ["enter"])
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(item.text), 1),
                        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(item.subtext), 1)
                      ])
                    ], 40, _hoisted_10),
                    (index < inflationDropdownItems.length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 64))
              ])
            ], 512), [
              [_vShow, inflationPresentationChoiceVisible.value]
            ]),
            _createElementVNode("div", {
              id: "showInTodaysMoneyButton",
              class: _normalizeClass(["d-flex btn btn-outline-secondary p-2 align-items-center me-3 vspace-on-wrap", { 'disabled': presentationChoiceButtonsDisabled.value }])
            }, [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  id: "todaysMoneyCheckboxId",
                  type: "checkbox",
                  disabled: presentationChoiceButtonsDisabled.value || presentationUpdateOngoing.value,
                  class: "form-check-input todays-money-chk",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showWhatThisIsWorthToday).value = $event)),
                  role: "switch"
                }, null, 8, _hoisted_16), [
                  [_vModelCheckbox, showWhatThisIsWorthToday.value]
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("label", {
                  class: "form-check-label text-muted todays-money-label",
                  for: "todaysMoneyCheckboxId"
                }, " Show in today's money ", -1))
              ]),
              _createVNode(Help, {
                title: "Today's money",
                enabled: !presentationChoiceButtonsDisabled.value,
                text: _unref(HelpText).todaysMoney()
              }, null, 8, ["enabled", "text"])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createVNode(IncomeDescriber, {
        "show-description": annualIncomes.length > 0,
        "initial-planning-year": initialPlanningYear.value,
        "plan-years": _unref(planYears),
        "retiring-on-jan-first": retiringOnJanFirst.value,
        planYear: selectedYear.value,
        amount: annualIncomes[selectedYear.value],
        onYearSelected: onMobileChartYearSelected,
        onEdit: onMobileEditClicked,
        onDecrement: onDecrementIncomeClicked,
        onIncrement: onIncrementIncomeClicked,
        "edit-disabled": isReadOnly.value.editButtonsDisabled,
        "increment-buttons-visible": false
      }, null, 8, ["show-description", "initial-planning-year", "plan-years", "retiring-on-jan-first", "planYear", "amount", "edit-disabled"]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(IncomeScale, {
            "max-value": maxIncome.value,
            disabled: !hasData.value
          }, null, 8, ["max-value", "disabled"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(annualIncomes.slice(0, _unref(planYears)), (annualIncome, i) => {
            return (_openBlock(), _createBlock(AnnualExpense, {
              key: i,
              modelValue: annualIncomes[i],
              "onUpdate:modelValue": ($event: any) => ((annualIncomes[i]) = $event),
              planYear: i + 1,
              "calendar-year": initialPlanningYear.value + i,
              "starts-on-jan-first": retiringOnJanFirst.value,
              max: maxIncome.value,
              min: minIncome,
              step: step.value,
              "is-read-only": isReadOnly.value.slidersDisabled,
              "is-selected": selectedYear.value == i,
              onGotFocus: ($event: any) => (selectedYear.value = i),
              orientation: "vertical"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "planYear", "calendar-year", "starts-on-jan-first", "max", "step", "is-read-only", "is-selected", "onGotFocus"]))
          }), 128)),
          (annualIncomes.length == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, " "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("p", {
            class: _normalizeClass(_unref(getDisabledClasses)(!hasData.value))
          }, "Retirement Year", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(MobileIncomeChart, {
          data: mobileData,
          onYearSelected: onMobileChartYearSelected
        }, null, 8, ["data"])
      ])
    ]),
    _createVNode(Modal, {
      title: setAllText.value,
      ref_key: "incomeSetupModal",
      ref: incomeSetupModal,
      idKey: "incomeSetup"
    }, {
      default: _withCtx(() => [
        _createVNode(InitialIncomeSetup, {
          ref_key: "incomeSetupModalUI",
          ref: incomeSetupModalUI,
          modalMode: true,
          baseIncome: quickSetValuesTracker.baseIncome,
          extraInitialIncome: quickSetValuesTracker.extraIncome,
          onPopulateIncomePlan: setupIncome,
          onCancelled: closeSetupModal
        }, null, 8, ["baseIncome", "extraInitialIncome"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Modal, {
      title: yearIncomeModalTitle.value,
      ref_key: "yearIncomeModal",
      ref: yearIncomeModal,
      "id-key": "yearEditor"
    }, {
      default: _withCtx(() => [
        _createVNode(YearEditor, {
          ref_key: "yearIncomeModalUI",
          ref: yearIncomeModalUI,
          onUpdateYear: updateYearIncome,
          onCancelled: closeYearIncomeModal
        }, null, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Modal, {
      title: "Income edit mode",
      ref_key: "incomeEditModeModal",
      ref: incomeEditModeModal,
      "id-key": "incomeEditMode",
      "close-button-aria-label": editModeConfirmationAria()
    }, {
      default: _withCtx(() => [
        _createVNode(EditableProjectionQuery, {
          ref_key: "incomeEditModeModalUI",
          ref: incomeEditModeModalUI,
          onEditModeRequired: onEditModeRequired,
          onCancelled: closeIncomeEditModeModal
        }, null, 512)
      ]),
      _: 1
    }, 8, ["close-button-aria-label"])
  ], 64))
}
}

})